module.exports = __webpack_public_path__ + "img/heart.c3efa64c.svg";